module.exports = __webpack_public_path__ + "img/sv43.c8559558.svg";